import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';

import arrowImageUrl from '../../../icons/arrow.svg';
import satelliteImageUrl from '../../../icons/satellite.svg';
import vesselImageUrl from '../../../icons/vessel.svg';
import { Card } from '../../Atoms/Card';

const formatLocationSource = ({ state, source }) => {
  if (state !== 'Acquired') return 'GPS';

  return `${source === 'Puck' ? 'Antenna' : 'Backup'} GPS`;
};

const formatLatitude = ({ state, latitude } = {}) => {
  if (state !== 'Acquired' || typeof latitude !== 'number') return '-';

  if (latitude >= 0) return `${latitude.toFixed(4)}°N`;

  return `${-latitude.toFixed(4)}°S`;
};

const formatLongitude = ({ state, longitude } = {}) => {
  if (state !== 'Acquired' || typeof longitude !== 'number') return '-';

  if (longitude >= 0) return `${longitude.toFixed(4)}°E`;

  return `${-longitude.toFixed(4)}°W`;
};

const formatHeading = ({ source, heading } = {}) => {
  if (!source || source === 'Unknown' || !heading || heading === 999) {
    return 'No Heading Available';
  }

  return `${parseFloat(heading).toFixed(1)}°T`;
};

const VesselSatellitePosition = ({ azBow, heading, location, vesselName }) => {
  return (
    <Card title="Real-time Vessel & Satellite Display">
      <div className="position-relative">
        {location && (
          <div
            className={classNames(
              'position-absolute d-flex flex-column py-1 px-2 ml-n4',
              'text-white text-sm bg-primary',
            )}
            style={{ lineHeight: '1.2' }}
          >
            <strong>{formatLocationSource(location)}</strong>
            <span>{formatLatitude(location)}</span>
            <span>{formatLongitude(location)}</span>
          </div>
        )}

        <p className="text-center text-primary my-3">
          <strong>{formatHeading(heading)}</strong>
        </p>

        <div className="position-relative text-center mb-3">
          <img
            src={arrowImageUrl}
            alt="Arrow"
            className="position-absolute"
            style={{
              height: '4%',
              left: '50%',
              top: '-3%',
              transform: 'translateX(-50%)',
              zIndex: 0,
            }}
          />

          <img
            src={vesselImageUrl}
            alt="Vessel"
            className="position-relative img-fluid"
            style={{ maxWidth: '100%', zIndex: 1 }}
          />

          {typeof azBow === 'number' && (
            <img
              src={satelliteImageUrl}
              alt="Satellite"
              className="position-absolute"
              style={{
                height: '107%',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) rotate(${azBow}deg)`,
                zIndex: 2,
              }}
            />
          )}
        </div>
      </div>

      <h5 className="text-center text-blue-dark">{vesselName}</h5>
    </Card>
  );
};

VesselSatellitePosition.propTypes = {
  azBow: PropTypes.number,
  heading: PropTypes.shape({
    heading: PropTypes.number.isRequired,
    source: PropTypes.string.isRequired,
  }),
  location: PropTypes.shape({
    state: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    source: PropTypes.string.isRequired,
  }),
  vesselName: PropTypes.string,
};

export default VesselSatellitePosition;
